import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mountain, ArrowLeft } from "lucide-react";
import { api, formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [sent, setSent] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email });
            setSent(true);
            toast.success("If the email exists, a reset link has been sent.");
        } catch (err) {
            toast.error(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-alpine-mist flex items-center justify-center p-6">
            <div className="w-full max-w-md">
                <Link to="/login" data-testid="forgot-back-login" className="inline-flex items-center gap-2 text-sm font-bold text-midnight-pine mb-8">
                    <ArrowLeft className="w-4 h-4" /> Back to log in
                </Link>
                <div className="flex items-center gap-2 mb-8">
                    <div className="w-9 h-9 rounded-md bg-midnight-pine flex items-center justify-center">
                        <Mountain className="w-5 h-5 text-ember-orange" />
                    </div>
                    <span className="font-display font-black text-xl text-midnight-pine">RealWorld Outdoors</span>
                </div>
                <h1 className="font-display font-black text-4xl text-midnight-pine tracking-tight mb-2">
                    Forgot password?
                </h1>
                <p className="text-slate-gray mb-8">
                    Enter your email and we'll send you a reset link. This is a placeholder — check backend logs for the reset URL.
                </p>

                {sent ? (
                    <div className="bg-moss/10 border border-moss/30 rounded-md p-5 text-sm text-granite">
                        <strong className="font-bold text-moss block mb-1">Check your email</strong>
                        If an account exists for that email, a reset link has been sent. (For demo purposes, the link is logged to the backend console.)
                    </div>
                ) : (
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <input
                            data-testid="forgot-email-input"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className="w-full px-4 py-3 rounded-md bg-snowcap border border-ridge-line focus:border-ember-orange focus:outline-none focus:ring-2 focus:ring-ember-orange/20"
                            placeholder="you@trailhead.com"
                        />
                        <button
                            type="submit"
                            data-testid="forgot-submit-btn"
                            disabled={loading}
                            className="w-full py-3 rounded-md bg-ember-orange text-white font-bold hover:bg-ember-dark active:scale-[0.99] disabled:opacity-60 transition-all"
                        >
                            {loading ? "Sending…" : "Send reset link"}
                        </button>
                    </form>
                )}
            </div>
        </div>
    );
}
